import React from 'react';
import styled from 'styled-components';
import { media, layout, remCalc } from 'src/components/base';
import { Button } from 'src/components/button';
import { IconGraph } from '@prisjakt/ui/icon/graph';
import { PageHeader } from 'src/components/page';

export const Header = styled(PageHeader)`
  display: flex;
  flex-direction: row;
  color: $text-color;
  ${media.smallOnly`
    flex-direction: column;
  `}
`;

export const Image = styled.img`
  height: 31px;
  width: auto;
  margin: 5px;
`;

export const Analytics = styled.div`
  padding: ${remCalc(5)} 0;
  svg {
    fill: #fff;
    margin-right: 5px;
  }
`;

export const AnalyticsButton = styled(Button).attrs({
  size: 'small',
  color: 'primary',
  icon: <IconGraph />,
})``;

export const Content = styled.div`
  padding: 0 ${layout.measurements.spacing050};
`;

export const BreadCrumbWrapper = styled.div`
  margin: ${layout.measurements.spacing050} ${layout.measurements.spacing050}
    ${layout.measurements.spacing050} 0;
`;
